<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div
      class="group"
      v-if="$can('read', 'hydrants') || $can('edit', 'hydrants')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('hydrantsRegisterModal')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR HYDRANTÓW</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'inspections_registry')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('inspectionRegisterModal')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR PRZEGLĄDÓW</span>
      </button>
    </div>
    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
export default {
  components: {
    vueCustomScrollbar
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/Hydrants.vue